import Rest from 'services/data/rest';

class Vendor extends Rest {
  static path = 'vendor';
  static defaultQuery = {
    sort: 'vendor'
  };
}

export default Vendor;
